import React from 'react';
import { ChevronDown } from 'lucide-react';
export function Navigation() {
  const navItems = [{
    label: 'Business',
    hasDropdown: true
  }, {
    label: 'Operations',
    hasDropdown: true
  }, {
    label: 'Writers',
    hasDropdown: true
  }, {
    label: 'Multimedia',
    hasDropdown: true
  }, {
    label: 'Resources',
    hasDropdown: true
  }, {
    label: 'Advertising',
    hasDropdown: true
  }, {
    label: 'Subscribe',
    hasDropdown: true
  }, {
    label: 'MEAT + POULTRY RED BOOK®',
    hasDropdown: false
  }];
  return <nav className="hidden md:block py-3 border-b border-black" data-id="element-222">
      <ul className="flex flex-wrap justify-between items-center text-[15px] text-gray-800" data-id="element-223">
        {navItems.map((item, index) => <li key={index} data-id="element-224">
            <a href="#" className="flex items-center gap-1 hover:text-[#002f5f] transition-colors group" data-id="element-225">
              {item.label}
              {item.hasDropdown && <ChevronDown className="w-4 h-4 text-gray-500 group-hover:text-[#002f5f]" strokeWidth={2} data-id="element-226" />}
            </a>
          </li>)}
      </ul>
    </nav>;
}